import { cn } from '@/utils/cn';
import { BUTTON_SIZE, type ButtonSize, type ButtonVariant } from '@/design-system/tokens';
import type { AnchorHTMLAttributes, ReactNode } from 'react';

const variants: Record<ButtonVariant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  ghost: 'btn-ghost',
};

export interface ButtonAnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
}

/** External link (`<a href>`) styled as a standard boxed button. */
export function ButtonAnchor({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonAnchorProps) {
  return (
    <a className={cn('btn', variants[variant], BUTTON_SIZE[size], className)} {...props}>
      {children}
    </a>
  );
}
